"use strict";

var _utils = require("./utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

exports.onRouteUpdate = function (_ref, _ref2) {
  var location = _ref.location;
  var whitelistHostnames = _ref2.whitelistHostnames;

  if (process.env.NODE_ENV !== 'production' || typeof fathom === 'undefined' || !(0, _utils.isWhitelistedHostname)(whitelistHostnames, location.hostname)) {
    return;
  }

  if ((typeof fathom === "undefined" ? "undefined" : _typeof(fathom)) === 'object') {
    fathom.trackPageview();
  } else {
    fathom('trackPageview');
  }
};